import React, { useState, useEffect } from "react";
import { ParallaxScroll as Parallax } from "../aceternity/ui/parallax";
import { Input, Button, Slider } from "../aceternity/ui/helper";
import Image1 from "../temp_assets/temp1.png";
import Nav from "./Nav";
import "../index.css";
import { useDispatch, useSelector } from "react-redux";
import hero1 from "../temp_assets/image.png";
import hero2 from "../temp_assets/image2.png";
import {
  fetchAllProductsThunk,
  searchProductsByNameThunk,
  searchProductsByCategoriesThunk,
} from "../thunks/thunks";
import { Link, useLocation } from "react-router-dom";
import { IconSearch } from "@tabler/icons-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart, faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import Logo from "./Logo";
import "../styles/Nav.css";
import {
  FaCheck,
  FaEnvelope,
  FaFacebook,
  FaInstagram,
  FaStar,
  FaTwitter,
  FaWhatsapp,
} from "react-icons/fa6";
import "../styles/Search.css";

const SearchPage = () => {
  const location = useLocation();
  const {
    filteredItems: products,
    isLoading,
    error,
  } = useSelector((state) => state.products);
  const [sortedProducts, setSortedProducts] = useState(products);
  const [showItems, setShowItems] = useState(products);
  const [filters, setFilters] = useState({
    category: "",
    price: "",
    new: false,
    rating: "",
  });
  const [categoryFilters, setCategoryFilters] = useState([]);
  const [categoryFilter, setCategoryFilter] = useState("");
  const dispatch = useDispatch();

  const [searchTerm, setSearchTerm] = useState(""); // State for search term
  useEffect(() => {
    console.log(location.search);
    const queryParams = new URLSearchParams(location.search);
    const category = queryParams.get("category");
    console.log("QueryParams: ", queryParams);
    if (category) {
      setCategoryFilter(category);
    } else {
      setCategoryFilter(""); // Reset if no category is selected
    }
  }, [location]);

  // Filter products by category
  useEffect(() => {
    console.log("Category Filter:", categoryFilter);
    if (categoryFilter == "menswear" || categoryFilter == "kidswear") {
      dispatch(searchProductsByCategoriesThunk([categoryFilter]))
    } else {
      dispatch(searchProductsByCategoriesThunk([
        "contemporary western",
      "indo western",
      "trousseau collection",
      "designer suits",
      "designer kurtis",
      "designer sarees",
      "crop top",
      "skirts",
      "night wears",
      "designer fabrics",
      ]));
    }
  }, [categoryFilter, dispatch]);

  const handleSearch = () => {
    if (searchTerm.trim()) {
      // Dispatch the search action with the searchTerm
      dispatch(searchProductsByNameThunk(searchTerm.trim()));
    } else {
      dispatch(fetchAllProductsThunk());
    }
  };

  useEffect(() => {
    if (products.length !== 0) {

      setSortedProducts(products);
      setShowItems(products);
      console.log("FIREEEE, ", products, "ShowItems", showItems);
      
    }
  }, [products]);

  useEffect(()=>{
    console.log("ShowItems",showItems);
  },[showItems]);

  const handleFilterApply = async () => {
    console.log("Filters:", filters);
    if (filters.category.trim()) {
      const categories = filters.category
        .split(",")
        .map((cat) => cat.trim().toLowerCase());
      await dispatch(searchProductsByCategoriesThunk(categories));
      setSortedProducts(products);
    }
  };

  const categoryOptions = [
    "Contemporary Western",
    "Indo Western",
    "Trousseau Collection",
    "Designer Suits",
    "Designer Kurtis",
    "Designer Sarees",
    "Crop Top",
    "Skirts",
  ];

  const handleCategoryChange = (category) => {
    // Update the categoryFilters state correctly
    setCategoryFilters((prev) => {
      const updatedCategories = prev.includes(category)
        ? prev.filter((cat) => cat !== category) // Remove category if already selected
        : [...prev, category]; // Add category if not selected

      // After updating categoryFilters, update filters state
      setFilters((prevFilters) => ({
        ...prevFilters,
        category: updatedCategories.join(","),
      }));
      console.log("Category Filters:", updatedCategories);
      return updatedCategories;
    });
  };

  const images = [
    {
      image: hero1,
      text1: "EXPLORE WOMEN'S FASHION WITH",
      text2: "KARISHMA'S CLOSET",
      class1: "text-black",
      class: "text-pink-800 cinzel drop-shadow",
    },
    {
      image: hero2,
      text1: "EXPLORE MEN'S FASHION WITH",
      text2: "KARISHMA'S CLOSET",
      class1: "text-white",
      class: "text-black cinzel drop-shadow",
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000); // Change image every 5 seconds
    return () => clearInterval(interval); // Clear interval on component unmount
  }, []);

  const [selectedFilter, setSelectedFilter] = useState("");
  const [priceRange, setPriceRange] = useState(50); // Default value for slider

  const Filters = [
    { id: "new", label: "New" },
    { id: "price-asc", label: "Price ascending" },
    { id: "price-desc", label: "Price descending" },
    { id: "rating", label: "Rating" },
  ];

  const handleFilterClick = (id) => {
    setSelectedFilter(id);
    let sortedArray = [...sortedProducts];
    switch (id) {
      case "new":
        sortedArray.sort(
          (a, b) => new Date(b.dateAdded) - new Date(a.dateAdded)
        );
        break;
      case "price-asc":
        sortedArray.sort((a, b) => a.price - b.price);
        break;
      case "price-desc":
        sortedArray.sort((a, b) => b.price - a.price);
        break;
      case "rating":
        sortedArray.sort((a, b) => b.averageRating - a.averageRating);
        break;
      default:
        break;
    }
    setSortedProducts(sortedArray);
    setShowItems(sortedArray);
  };

  const handleSliderChange = (event) => {
    const newPriceRange = Number(event.target.value);
    setPriceRange(newPriceRange);
    const filteredByPrice = products.filter(
      (product) => product.price <= newPriceRange
    );

    setShowItems(filteredByPrice);
  };
  useEffect(() => {
    const filteredByPrice = products.filter(
      (product) => product.price <= priceRange
    );

    const filteredAndSorted = filteredByPrice.sort((a, b) => {
      if (selectedFilter === "price-asc") return a.price - b.price;
      if (selectedFilter === "price-desc") return b.price - a.price;
      if (selectedFilter === "rating") return b.averageRating - a.averageRating;
      if (selectedFilter === "new")
        return new Date(b.dateAdded) - new Date(a.dateAdded);
      return 0;
    });
    if (filteredAndSorted.length > 0) {
      setShowItems(filteredByPrice);
    }
    setShowItems(filteredAndSorted);
  }, [products, priceRange, selectedFilter]);

  return (
    <div className="flex flex-col min-h-screen">
      {/* Top Navbar */}
      <Nav />

      {/* Hero Section */}
      <div className=" my-20 overflow-hidden h-[20vh] md:h-[30vh] lg:h-[50vh]">
        <div
          className="flex transition-transform duration-1000"
          style={{
            transform: `translateX(-${currentIndex * 100}%)`,
          }}
        >
          {images.map((slide, index) => (
            <div
              key={index}
              className="relative w-full h-[20vh] md:h-[30vh] lg:h-[50vh] flex-shrink-0 bg-center bg-cover"
              style={{
                backgroundImage: `url(${slide.image})`,
              }}
            >
              <div className="absolute inset-0 flex items-center ">
                <h1 className="text-white text-2xl md:text-4xl font-bold text-left px-4 font-cinzel ">
                  <span className={`text-sm md:text-lg lg:text-2xl ${slide.class1}`}>
                    {slide.text1}
                  </span>
                  <br />
                  <span className={`text-xl md:text-4xl lg:text-6xl font-extrabold ${slide.class} text-border`}>
                    {slide.text2}
                  </span>
                </h1>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Search Bar */}
      <div className="flex justify-center items-center py-4 px-[10%]">
        <input
          type="text"
          placeholder="Search"
          className="w-full py-2 px-4 text-xl mx-2 border-2 border-gray-200 rounded-full"
          value={searchTerm} // Controlled input for search term
          onChange={(e) => setSearchTerm(e.target.value)} // Update search term
        />
        <button
          onClick={handleSearch}
          className="text-gray-600 hover:text-gray-900 hover:bg-gray-200 p-2 rounded-lg relative left-[-60px] rounded-full"
        >
          <IconSearch />
        </button>
      </div>

      {/* Filter Buttons */}
      <div className="flex-col md:flex items-center mb-4 justify-around">
        {/* Price Range Slider */}
        <div className="flex flex-col sm:flex-row items-center w-[80%] justify-center gap-10 ml-4">
          <div>
            <label htmlFor="price-slider" className="mr-4 text-gray-700">
              Price Range: ₹{priceRange}
            </label>
            <input
              id="price-slider"
              type="range"
              min="0"
              max="20000"
              step="0"
              value={priceRange}
              onChange={handleSliderChange}
              className="w-full slider"
            />
          </div>

          <div className="flex flex-wrap items-center justify-center">
            {Filters.map((filter) => (
              <button
                key={filter.id}
                onClick={() => handleFilterClick(filter.id)}
                className={`flex items-center p-2 rounded-md text-white mx-2 mb-2 pointer w-auto ${
                  selectedFilter === filter.id
                    ? "bg-pink-800"
                    : "bg-custom-pink"
                }`}
              >
                {selectedFilter === filter.id && (
                  <FaCheck className="mr-2 text-green" />
                )}
                {filter.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex flex-col md:flex-row flex-grow">
        {/* Filters */}
        {categoryFilter == "women" && (
          <aside className="w-3/4 ml-auto mr-auto w-full md:w-1/4 border-2 border-gray-200 p-6 md:m-16 rounded-md">
            <h2 className="text-xl font-semibold mb-4">Filters</h2>
            {/* Categories */}
            <div>
              <h3 className="font-medium">Categories</h3>
              {categoryOptions.map((category, index) => (
                <label key={index} className="block mt-2">
                  <input
                    type="checkbox"
                    checked={categoryFilters.includes(category)}
                    onChange={() => handleCategoryChange(category)}
                    className="mr-2"
                  />
                  {category}
                </label>
              ))}
            </div>

            <Button
              onClick={handleFilterApply}
              className="w-full mt-4 bg-pink-400 hover:bg-pink-800"
            >
              Apply Filters
            </Button>
          </aside>
        )}

        {/* Products */}
        <main className="w-full md:w-3/4 p-6">
            {products.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 h-[fit-content]">
              {products.map((product, index) => (
                <div key={index} className="border p-4 rounded h-[90%]">
                  <div className="relative h-[85%] mb-2">
                    <img
                      src={product.imageFileName || Image1}
                      alt={product.name}
                      className="w-full h-[100%] object-fit"
                    />
                    {/* Rating positioned at bottom-left on the image */}
                    <div className="relative bottom-16 left-2 bg-gray-100 p-2 rounded-lg w-[fit-content] bg-opacity-70 ">
                      <div className="flex items-center">
                        {product.averageRating || "?"}
                        <FaStar className="text-yellow-500" />
                      </div>
                    </div>
                  </div>

                  <h3 className="text-lg font-semibold">{product.name}</h3>
                  <p className="text-gray-600">{product.categories[0]}</p>
                  <div className="flex items-center">
                    <p className="text-gray-600">₹{product.price}</p>
                    <FontAwesomeIcon
                      icon={faShoppingCart}
                      className="mr-4 ml-2"
                    />
                    <FontAwesomeIcon icon={faHeart} className="mr-2" />
                  </div>
                </div>
              ))}
            
          </div>
        ) : (
          <div className="text-center font-bold text-2xl items-center">No products found ....</div>
        )}
        </main>
      </div>

      {/* Footer */}
      <footer className="border-t-2 border-gray-500 py-4 text-center px-2 ">
        <div className="flex flex-col md:flex-row items-center justify-between mx-8">
          <Link to="/" className="m-3 hidden sm:block">
            <Logo />
          </Link>

          <p className="mx-4">
            &copy; 2025 Karishma's Closet. <br /> All rights reserved.
          </p>

          {/* Social Media Icons */}
          <div className="flex space-x-4">
            <a href="https://wa.me/" target="_blank" rel="noopener noreferrer">
              <FaWhatsapp size={24} className="hover:text-green-700" />
            </a>
            <a
              href="https://www.instagram.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram size={24} className="hover:text-purple-800" />
            </a>
            <a
              href="mailto:example@example.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaEnvelope size={24} className="hover:text-gray-900" />
            </a>
            <a
              href="https://www.facebook.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebook size={24} className="hover:text-blue-800" />
            </a>
            <a
              href="https://twitter.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaTwitter size={24} className="hover:text-blue-600" />
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default SearchPage;
